




























































































import { Component, Mixins } from "vue-property-decorator";
import { OrderMixin } from "@/mixins/orders/mixin";
import CheckoutForm from "@/components/checkout/CheckoutForm.vue";
import OrderSummary from "@/components/checkout/OrderSummary.vue";
import { OrderType } from "@/models/order/helpers";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions, OrderGetters } from "@/store/modules/order/types";
import { Order } from "@/models/order/order";
import ConfirmNewQuote from "@/components/elements/modal/ConfirmNewQuote.vue";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { PriceLevel } from "@/models/netsuite/netsuite";
import NetSuiteService from "@/services/netsuite_service";
import { GenericError } from "@/services/error_service";
@Component({
  components: {
    CheckoutForm,
    OrderSummary,
    ConfirmNewQuote
  }
})
export default class Submitted extends Mixins(OrderMixin) {
  @(namespace(StoreModule.Order).Action(OrderActions.ClearOrder))
  resetOrder!: () => Promise<void>;
  // `items` is inherited from OrderMixin (same GetOrderItems getter).
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  order!: Order;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: PriceLevel | null) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetPriceLevels))
  storePriceLevels!: PriceLevel[];
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetRole))
  userRole!: string;
  protected orderType = OrderType;
  protected showModal = false;
  protected uniqueEmails: string[] = [];
  protected downloading = false;
  protected netSuiteService = new NetSuiteService();

  created(): void {
    if (this.order.items?.length === 0) {
      this.$router.replace("/");
    } else {
      const orderEmails: string[] = [this.order.contact_details.email];
      if (this.order.billing_details?.email) {
        orderEmails.push(this.order.billing_details.email);
      }
      if (this.order.shipping_details?.email) {
        orderEmails.push(this.order.shipping_details.email);
      }
      orderEmails.filter(email => {
        if (!this.uniqueEmails.includes(email)) {
          this.uniqueEmails.push(email);
        }
      });
    }
  }

  async mounted(): Promise<void> {
    await this.resetOrder();
    // if (this.$route.query.type === OrderType.Order) {
    // if (this.$route.query.type === OrderType.Quote) {
    // }
  }

  get quote(): boolean {
    let type = false;
    if (this.$route.query.type === OrderType.Quote) {
      type = true;
    }
    return type;
  }

  get emailSent(): boolean {
    return this.$route.query.emailSent === "1";
  }

  get quoteId(): number | null {
    const id = this.$route.query.quoteId;
    return id ? Number(id) : null;
  }

  get tranId(): string | null {
    return (this.$route.query.tranId as string) || null;
  }

  protected async downloadQuotePdf(): Promise<void> {
    if (!this.quoteId) return;
    this.downloading = true;
    try {
      const blobData = await this.netSuiteService.getQuotePdf(this.quoteId);
      const fileName = this.tranId
        ? `Frankford Umbrellas Quote #${this.tranId}`
        : `Frankford Umbrellas Quote`;
      const url = window.URL.createObjectURL(blobData);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${fileName}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      GenericError.popup(err.message);
    } finally {
      this.downloading = false;
    }
  }

  protected hasPunctuation(index: number): boolean {
    const emailsLength = this.uniqueEmails.length;
    let result = false;
    if (emailsLength > 1 && emailsLength - 1 !== index) {
      result = true;
    }
    return result;
  }

  protected isNextToLastEmail(index: number): boolean {
    const emailsLength = this.uniqueEmails.length;
    let result = false;
    if (emailsLength > 1 && emailsLength - 2 === index) {
      result = true;
    }
    return result;
  }

  protected toggleNewQuoteModal(): void {
    if (this.items.length > 0) {
      // only toggling warning modal if there is an item associated with the order
      this.showModal = true;
    } else {
      this.clearOrder();
    }
  }

  protected close(): void {
    this.showModal = false;
  }

  protected async clearOrder(): Promise<void> {
    this.close();
    await this.resetOrder();
    const baseLevel = this.storePriceLevels.find(l => l.id === 1) ?? null;
    await this.addMultiplier(baseLevel);
    if (this.$route.path !== "/collections/umbrella") {
      this.$router.push("/collections/umbrella");
    }
  }
}
